<template>

<StyleProductDefault
    v-if="item && company" class="product-default"
    :class="[

        !related && layout_mode === 'grid' ? 'text-center '+(!class_responsive_when_side_menu ? (!$root.$children[0].theme.products.responsive_images_class ? 'col-6 col-sm-4 col-md-3 col-lg-2' : $root.$children[0].theme.products.responsive_images_class) : class_responsive_when_side_menu) : null,

        layout_mode == 'list' ? `${carousel_products == true ? '' : 'col-6'} col-sm-12 left-details ${carousel_products == true ? '' : 'product-list'} mb-4` : null,

        related ? ' left-details product-widget' : null,

        activeProductBoxShadowHover && 'product-hover-shadow'

    ]"

>

    <figure>

        <a
            @click.prevent="openProductModal == false ? productPage() : modalProduct()" :href="item.url_pro"
            :style="`${apply_height_img == true ? 'display: flex; justify-content: center;' : ''}`"
        >

            <picture>

                <source

                    v-if="$productImageSrcset(item.image_main)"

                    type="image/webp"

                    :srcset="$productImageSrcset(item.image_main)"

                    :sizes="apply_height_img ? `${image_height}px` : '(max-width: 575px) 50vw, 220px'"

                >

                <img

                    :src="item.image_main"

                    :alt="item.pro_name_site"

                    loading="lazy"

                    :style="`

                        position: relative; opacity: 1;

                        ${apply_height_img == true ?

                            'height:' + (!related ? image_height + 'px' : 'auto; width: 84px') + '; object-fit: '+ object_fit_img +';' : ''}

                        `"

                >

            </picture>

        </a>

    </figure>

    <div class="product-details" :style="`padding: ${search == true ? '0 10px 0 10px' : '0'};`">

        <div v-if="!related && !page_wish_list" class="category-list">

            <a href="#" class="product-category" :aria-label="'Categoria '+item.cat_name">

                {{item.cat_name}}

            </a>

        </div>

            <product-title-def :class="['product-title ', related || page_wish_list ? 'align-title-list' : 'align-title']">

            <a @click.prevent="openProductModal == false ? productPage() : modalProduct()" :href="item.url_pro">

                <template v-if="showCodeOriginal">{{ item.api_cod_original }} - </template>

                {{ product_name_site }}

            </a>

            </product-title-def>

        <strong v-if="activeBrandName">

           Marca: {{item.brand_name}}

        </strong>

        <Rating v-if="showRatings" :item="item" :layoutLeft="related || page_wish_list"/>

       

        <product-price-box :class="['price-box', related || page_wish_list ? 'align-price-box-left' : 'align-price-box']">

            <Fragment

                v-if="

                    !item.price_on_request &&

                    ((((item.pro_stock_site > 0 && item.minimum_sale_quantity <= item.pro_stock_site) || item.sell_out_of_stock == true) &&

                    company.finalizacao_pagamento.tipo == 'PAGAMENTO') ||

                    (company.finalizacao_pagamento.mostrar_preco && company.finalizacao_pagamento.tipo == 'ORCAMENTO'))

                "

            >

                <template v-if="hidePrice == false">

                    <span class="from-price" v-if="item.product_type_id == TYPE_VARIATION && !validateProductGroup">A partir de </span>

                    <span

                        v-if="( item.price_to || (

                                item.from_price_site && item.pro_price_site && item.pro_price_site > item.from_price_site

                                && +item.pro_price_site != +item.from_price_site )

                            )"

                        class="old-price"

                    >

                        {{currency.money(item.pro_price_site || item.from_price_site)}}

                    </span>

                    <span v-if="hasPriceTo">por</span>

                    <product-price class="product-price">

                        {{ !item.price_to ? currency.money(item.from_price_site || item.pro_price_site ) : currency.money(item.price_to) }}

                        <small v-if="getShowUnitOfMeasureInProductPrice" style="font-size: 60%">

                            {{ item.pro_sigla_medida }}

                        </small>

                    </product-price>

                    <br style="margin-bottom: 5px;">

                    <InterestFreeInstallments

                        :item="item"

                        :related="related"

                        :page_wish_list="page_wish_list"

                    />

                    <br>

                </template>

                

            </Fragment>

            <span

                class="product-unavailable"

                v-if="

                    (item.pro_stock_site <= 0 || item.minimum_sale_quantity > item.pro_stock_site) &&

                    item.out_of_stock_unavailable &&

                    item.sell_out_of_stock == false &&

                    !item.price_on_request &&

                    company.finalizacao_pagamento.tipo == 'PAGAMENTO'

                "

            >

                produto <strong>indisponível</strong>

            </span>

           

        </product-price-box>

    </div>

</StyleProductDefault>

</template>

<script>

import { CWishList } from '../../components/Styles/WishList/styled';

import Currency from '../../helpers/parseCurrency'

import {mapActions, mapGetters, mapState } from 'vuex'

import {Fragment} from 'vue-fragment'

import InterestFreeInstallments from '../../components/product/InterestFreeInstallments.vue'

import Rating from '../../components/product/Rating.vue'

import {TYPE_PRODUCT, TYPE_VARIATION} from '../../services/product'


import { swall } from '../../services/sweetAlert'

import {

    CProductTitleDefault,

    CProductPrice,

    CProductPriceBox,

    StyleProductDefault

} from '../../components/Styles/Product/styled';

export default {

    name: 'Product',

    components: {

        'c-wish-list': CWishList,

        InterestFreeInstallments,

        Fragment,

        StyleProductDefault,

        Rating,

        'product-title-def': CProductTitleDefault,

        'product-price': CProductPrice,

        'product-price-box': CProductPriceBox,

    },

    props: {

        isSharedWishlist: {

            required: false,

            default: false

        },

        pro: {

            required: true

        },

        wishlist: {

            default: null

        },

        related: {

            default: false

        },

        layout_mode: {

            default: 'grid',

            type: String

        },

        page_wish_list: {

            default: false

        },

        products_settings: {

            required: true

        },

        search: {

            default: false

        },

        class_responsive_when_side_menu: {

            type: String

        },

        session_news: {

            default: false

        },

        carousel_products: {

            default: false

        }

    },

    data() {

        return {

            currency: Currency,

            item: this.pro,

            image_height: this.products_settings?.altura_imagem ?? '450',

            apply_height_img: this.$root.$children[0].theme?.products?.apply_height_img ?? false,

            object_fit_img: this.$root.$children[0].theme?.products?.object_fit_img ?? 'cover',

            active_icon_visualizar: this.$root.$children[0].theme?.products?.button?.active_icon_visualizar ?? false,

            padding_button: this.$root.$children[0].theme?.products?.button?.padding ?? '0 1rem',

            padding_button_cart: this.$root.$children[0].theme?.products?.button?.padding_cart ?? '0 1rem',

            active_only_btn_buy: this.$root.$children[0].theme?.products?.button?.active_only_btn_buy ?? false,

            is_budget_layout: this.$root.$children[0].theme?.is_budget_layout ?? false,

            TYPE_PRODUCT,

            TYPE_VARIATION

        }

    },


    methods: {

        ...mapActions("products", [

            "ActionSetItem",

            "ActionResetCarouselModal",

            "ActionGetProduct",

            "setConversionUnitWhenSellingWithClosedBox",

            "setAdditionalItems",

            "setResetItemsGrid",

            "setResetProduct",

            "setQuantity",

            "ActionResetAdditionalItems",

        ]),

        ...mapActions("tellMeWhenArrive", ["setProductTellMeWhenArrive"]),

        ...mapActions("clients", [

            "ActionSetEmailRegister"

        ]),

        ...mapActions("wishlist", [

            "ActionInsertItemWishList",

            "ActionRemoveItemWishList",

        ]),

        async modalProduct() {

            this.setResetItemsGrid(true)

            setTimeout(() => {

                this.setResetItemsGrid(false)

            }, 100)

            this.$root.ajaxLoadingApp()

            localStorage.setItem('reset', 'true')

            // localStorage.setItem('reset_product_modal','true')

            jQuery('.product-single-carousel-quick-view').owlCarousel('destroy')

            await this.getProduct(this.item.id)

            if(this.facebookPixel?.settings?.ViewContent == true) {

                fbq('track', 'ViewContent')

            }

            if(typeof gtag === 'function') {

                gtag('event', 'view_item', {

                    'pageTitle': this.company.nome_fantasia,

                    'pageCategory': 'Produto',

                    'ecommerce': {

                        'currency': 'BRL',

                        'value': this.item.pro_price_site,

                        'products': [{

                            'id' : this.item.api_cod_original ?? '',

                            'name': this.item.pro_name_site,

                            'price': this.item.pro_price_site,

                            'category': this.item.cat_name

                        }],

                    }

                });

            }

            this.setConversionUnitWhenSellingWithClosedBox('UND')

            this.setAdditionalItems([])

            this.ActionResetAdditionalItems();

            this.setQuantity(this.minimumQuantity);

            this.setResetProduct(true);

            setTimeout(async () => {

                $('.quantity-linked-products-end-page').each(function() {

                    $(this).val(null)

                })

                await this.ActionResetCarouselModal('product-single-carousel-quick-view')

                await this.$root.ajaxLoadingRemoveApp()

                this.setResetProduct(false);

                this.$root.showModalApp('product_modal')

                document.getElementById('product_modal').style.overflow = 'auto'

            }, 100)

        },

        async getProduct(id) {

            await this.ActionGetProduct(id)

                .then(async (resp) => {

                    let {

                        data

                    } = resp

                    await this.ActionSetItem(data)

                    await this.setProductTellMeWhenArrive(data)

                })

                .catch((error) => {

                    swall(error?.msg ?? error)

                })

        },

        async productPage() {

            window.location = this.item.url_pro

        },

        showProductActions() {

            return (

                this.showProductPurchaseButtons &&

                !this.related &&

                !this.page_wish_list &&

                (((

                    (this.item.pro_stock_site > 0 && this.item.minimum_sale_quantity <= this.item.pro_stock_site) ||

                    this.item.sell_out_of_stock == true

                ) &&

                this.company.finalizacao_pagamento.tipo == 'PAGAMENTO' || this.item.price_on_request) ||

                (this.company.finalizacao_pagamento.tipo == 'ORCAMENTO'))

            );

        },

        

    },

    watch: {

        itemWish(item) {

            if (!item || item == "") {

                return

            }

            if (item.id === this.item.id) {

                this.item.wish = item.wish

            }

        }

    },

    computed: {

        ...mapState("products", [

            "itemWish",

            "conversionUnitWhenSellingWithClosedBox",

            "minimumQuantity"

        ]),

        ...mapState("company", [

            "company",

            "facebookPixel",

            "googleAds",

            "socials"

        ]),

        ...mapGetters('company', [

            "showRatings",

            "getShowUnitOfMeasureInProductPrice",

            "showCodeOriginalBesideDescription"

        ]),

        showCodeOriginal() {

            return (

                this.showCodeOriginalBesideDescription &&

                this.item.api_cod_original

            );

        },

        product_name_site() {

            let textTransform = this.$root.$children[0].theme?.products?.text_transform ?? ''

            return textTransform == 'uppercase' ? this.item.pro_name_site.toUpperCase() :

                textTransform == 'lowercase' ? this.item.pro_name_site.toLowerCase() :

                textTransform == 'initial' ? (this.item.pro_name_site.charAt(0).toUpperCase() + this.item.pro_name_site.toLowerCase().substr(1)) :

                textTransform == 'capitalize' ? (this.item.pro_name_site.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })) : this.item.pro_name_site

        },

        hidePrice() {

            let hide = this.company?.settings?.hide_price_not_logged_user ?? false

            return ( hide === false ) ? false : ( hide === true && this.isLogged === false ? true : false )

        },

        isLogged() {

            return this.$root.$children[0].$attrs.logged

        },

        validateProductGroup() {

            return (this.activateSaleProductGroups && this.isProductGroup)

        },

        isProductGroup() {

            return this.productSettings?.is_product_group ?? false

        },

        productSettings(){

            if(this.item?.settings) {

                return JSON.parse(this.item.settings)

            }

            return null

        },

        activateSaleProductGroups() {

            return this.$root.$children[0].$attrs.company?.settings?.activate_sale_product_groups ?? false

        },

        textButtonOpenModal() {

            return (this.active_only_btn_buy == true ?

                (this.$root.$children[0].theme.products.button.content_button) : '')

        },

        showShadowIconWishlist() {

            return this.$root.$children[0].theme?.products?.icon_wishlist?.show_shadow ?? true

        },

        activeProductBoxShadowHover() {

            return (this.$root.$children[0].theme?.products?.box_shadow_hover?.active_box_shadow ?? false) && !this.related;

        },

        showProductPurchaseButtons() {

            return this.$root.$children[0].theme?.products?.button?.active_product_purchase_buttons ?? true;

        },

        activeIconWishlist() {

            return this.$root.$children[0].theme?.products?.icon_wishlist?.active_icon_wishlist ?? true

        },

        activeBrandName() {

            return this.$root.$children[0].theme?.products?.active_brand_name ?? false

        },

        openProductModal() {

            return this.$root.$children[0].theme?.products?.open_product_modal ?? false

        },

        hasPriceTo() {

            return (

                this.item.price_to &&

                Number(this.item.price_to) !=

                    Number(this.item.pro_price_site)

            );

        },

       

    },

}

</script>

<style scoped>

.shadow-wish {

    text-shadow: 2px 3px 8px #000;

}

@media (max-width: 768px) {

    .align-title {

        margin-left: auto;

        margin-right: auto;

        white-space: nowrap;

    }

}

</style>
